import React from "react";
import styled from "styled-components";

const VideoWrapper = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 60%;
  margin: 4rem auto;
`;

const VideoIframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const ResponsiveYoutubeVideo = ({ src }) => (
  <VideoWrapper>
    <VideoIframe src={src} />
  </VideoWrapper>
);

export default ResponsiveYoutubeVideo;
